import React from 'react';
import { Link } from 'react-router-dom';
import useAppStore from '../../store';

/**
 * 403 screen (T8.9): rendered by RequireRole when an authenticated user
 * requests a route their role cannot see. Names the role that was checked so
 * permission bugs surface instead of hiding behind a redirect.
 */
function ForbiddenPage({ attemptedRole }) {
  const session = useAppStore((state) => state.session);
  const isClient = session?.role === 'client';

  return (
    <main className="page-content forbidden-page">
      <section className="page-heading">
        <div>
          <p className="eyebrow">ACCESS DENIED</p>
          <h1>403 — Not your lane</h1>
          <span>
            Your role{attemptedRole ? ` (${attemptedRole})` : ''} is not cleared for this area.
            This attempt has been noted by human-in-the-loop governance.
          </span>
        </div>
      </section>
      <div className="empty-queue">
        <h3>{isClient ? 'This is agency operations space' : 'Missing clearance'}</h3>
        <p>
          {isClient
            ? 'Your portal is where your agents, activity, invoices, and support live.'
            : 'Ask an agency admin if you believe you should have access to this screen.'}
        </p>
        <Link className="primary-button" to={isClient ? '/client/home' : '/approvals'}>
          {isClient ? 'Go to your portal' : 'Back to approvals'}
        </Link>
      </div>
    </main>
  );
}

export default ForbiddenPage;
